

export default function useFlatPickr() {
  const addDots = (selectedDates, dateStr, instance, event) => {
    if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 95 && event.keyCode <= 106)) {
      let value = event.target.value ? event.target.value : ''
      if (value.length === 2 || value.length === 5) {
        value += '.'
        event.target.value = value
        event.target.dispatchEvent(new Event('input'))
      }
    }
  }

  return {
    addDots
  }
}